import { render, staticRenderFns } from "./EodbDomesticDetails.vue?vue&type=template&id=779442bc&scoped=true&"
import script from "./EodbDomesticDetails.vue?vue&type=script&lang=js&"
export * from "./EodbDomesticDetails.vue?vue&type=script&lang=js&"
import style0 from "./EodbDomesticDetails.vue?vue&type=style&index=0&id=779442bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779442bc",
  null
  
)

export default component.exports